export default {
  blog: () => import("/app/layouts/blog.vue").then(m => m.default || m),
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/app/layouts/empty.vue").then(m => m.default || m),
  sidebar: () => import("/app/layouts/sidebar.vue").then(m => m.default || m),
  subject: () => import("/app/layouts/subject.vue").then(m => m.default || m),
  "textbook-answer": () => import("/app/layouts/textbook-answer.vue").then(m => m.default || m),
  "textbook-list": () => import("/app/layouts/textbook-list.vue").then(m => m.default || m)
}